import React, { forwardRef, useEffect, useMemo, useRef, /*useImperativeHandle, useRef,*/ useState } from 'react'
import { FINDING_ACTIONS, FINDING_STATUS, FINDING_TICKET_STATUS, /*MAX_ACCEPT_RISK_COUNT,*/ FINDING_UPDATE_TASK_TYPES, TOOLS_NOT_FOR_FUTURE_FINDINGS, SIMILAR_FINDINGS_TAGS_OPERTAION_TYPES, SIMILAR_FINDINGS_TYPES } from './Constants';
import { CellRenderers } from "utils/tableUtils";
import { Form, Spin, Typography, Alert, Tooltip } from 'antd';
import { FieldTypes, generateFormFields } from 'utils/formUtils';
import Text from 'antd/lib/typography/Text';
import AppLoader from 'components/AppLoader';
import FindingAPI from 'restAPI/FindingAPI';
import BaseModal from 'components/BaseModal';
import ModalUtil from 'utils/modalUtil';
import _, { isEmpty, lowerCase, noop } from 'lodash';
// import TicketIdWithStatus from 'components/TicketIdWithStatus';
import Vocabulary from 'components/Vocabulary';
import AuthorisedContainer from 'components/AuthorisedContainer';
import { PermissionSetMap } from 'constants/RBACConstants';
import SuccessPopup from 'components/SuccessPopup';
import WarningPopup from 'components/WarningPopup';
import { hasPermission } from 'utils/authService';
// import AuthorisedCheckbox from 'components/AuthorisedCheckbox';
import { useFindingScopeFields } from './utils';
import message from 'components/CustomMessage';
import moment from 'moment';
import { DEFAULTS } from 'components/CustomDuration';
import { MODAL_SIZE_ULTRA } from 'constants/Layout';
import SimilarFindingsTable from './SimilarFindingsTable';
import { getTicketSystemName } from 'views/Integrations/new/util';
import { fetchConfigAndRedirect } from 'utils/securityToolUtil';

const AcceptRiskPopup = forwardRef(({finding, ticketDetails, afterClose, onOk, action, history, featureFlags, systemUsers, systemError, bucket}, ref) => {
    // const thisRef = useRef();
    // useImperativeHandle(ref, () => thisRef.current);
    const [form] = Form.useForm();
    const [acceptRiskCount, setAcceptRiskCount] = useState(0);
    const [maxAcceptRiskCount, setMaxAcceptRiskCount] = useState();
    const [loading, setLoading] = useState(false);
    const [similarFindings, setSimilarFindings] = useState(0);
    const {/*shouldConfigureOrEnableJira,*/ ticketId} = ticketDetails;
    const [rule, setRule] = useState(undefined);
    const [scope, setScope] = useState('FINDING');
    const [showFindingsTable, setShowFindingsTable] = useState(false);
    const similarFindingsToNotUpdate = useRef([]);
    const [updateType, setUpdateType] = useState(SIMILAR_FINDINGS_TYPES.RULE_BASED);
    const [tagCondition, setTagCondition] = useState('EQUALS');

    const [isControlledStatusAction] = useState(() => action === FINDING_ACTIONS.CONTROLLED);
    const findingUpdateTaskType = action === FINDING_ACTIONS.ACCEPT_RISK ? FINDING_UPDATE_TASK_TYPES.ACCEPT_RISK
        : (isControlledStatusAction ? FINDING_UPDATE_TASK_TYPES.CONTROLLED : FINDING_UPDATE_TASK_TYPES.OPEN);

    useEffect(() => {
        if(!scope || scope === 'FINDING' || !similarFindings){
            setRule(undefined);
            return noop;
        }
        const { promise, cancel } = FindingAPI.similarFindings.getRule({ 
            findingId: finding.id,
            taskType: (action === FINDING_ACTIONS.REJECT_RISK) || (action === FINDING_STATUS.OPEN) ? FINDING_UPDATE_TASK_TYPES.OPEN
                : (isControlledStatusAction ? FINDING_UPDATE_TASK_TYPES.CONTROLLED : FINDING_UPDATE_TASK_TYPES.ACCEPT_RISK),
            scope,
        });
        promise.then(setRule);
        return cancel;
    }, [finding.id, scope, action, similarFindings, isControlledStatusAction]);

    useEffect(() => {
        if(!isEmpty(rule)) {
            form.setFieldsValue({
                applyOnFutureFindings: false
            });
        }
    },[rule, form]);
    
    const isTicketCreationInProgress = (() => {
        if(_.isEmpty(ticketDetails.jiraTicketDetails)) {
            return false;
        }
        switch(ticketDetails.jiraTicketDetails[0].status){
            case FINDING_TICKET_STATUS.ERROR_OCCURRED:
            case FINDING_TICKET_STATUS.CREATE_FAILED:
              return false;
            default:
              return true;
        }
    })();

    // const [isCreateTicket, /*setIsCreateTicket*/] = useState(hasPermission(PermissionSetMap.CREATE_TICKETS) && !shouldConfigureOrEnableJira && !isTicketCreationInProgress);

    const fileList = [];
    // const fileChange = (file) => {
    //     if(file.file.status === 'removed') {
    //         _.remove(fileList, { name: file.file.name });
    //     } else {
    //         fileList.push(file.file);
    //     }
        
    //     const ellipsisLength= file.file.name.length >= 68
    //     message.success(<span>Successfully {file.file.status === 'removed' ? 'removed' : 'uploaded'} {ellipsisLength ? `${file.file.name.substring(0, 65)}...` : file.file.name}</span>)
    //   }

    // limit file upload size to 1 MB max
    // const checkFileSize = (file) => {
    //     const allFileSize = fileList.reduce((acc, currVal) => acc + currVal.size, 0);
    //     if((allFileSize + file.size) /1000000 > 1){
    //         message.error("All file size should be less than 1 MB");
    //         return Promise.reject();
    //     } else {
    //         return false;
    //     }
    // }

    useEffect(() => {
        let cancel = () => 0;
        if(finding?.id && action === FINDING_ACTIONS.ACCEPT_RISK ) {
            setLoading(true)
            const cancellablePromise = FindingAPI.getAcceptRiskCount(finding.id);
            cancel = cancellablePromise.cancel;
            cancellablePromise.promise.then(res => {
                setAcceptRiskCount(res.acceptRiskCount)
                setMaxAcceptRiskCount(res.maxAcceptRiskCount);
                setLoading(false)
            }, e => {
                console.log(e)
                setLoading(false);
            })
        }

        return cancel;
    }, [finding, action])

    const handleOnOk = async () => {
        await form.validateFields();
            let data = form.getFieldsValue();
            data = {
                ...data,
                file: fileList
            }

            if(!_.isEmpty(ticketId)){
                data.createTicket = false;
            }
            
            const unSeppress = data.unsupress?.neverOrAfter && data.unsupress.neverOrAfter !== 'Never';

            const response = {
                ...data,
                id: finding.id, 
                findingId: finding.id, 
                scope,
                updateType,
                contains: tagCondition === SIMILAR_FINDINGS_TAGS_OPERTAION_TYPES.contains,
                equals: tagCondition === SIMILAR_FINDINGS_TAGS_OPERTAION_TYPES.equals,
                status: action === FINDING_ACTIONS.ACCEPT_RISK ? FINDING_STATUS.ACCEPT_RISK : (isControlledStatusAction ? FINDING_STATUS.CONTROLLED : FINDING_STATUS.OPEN),
                unsupress: unSeppress,
                unsupressAfterDuration: unSeppress ? moment().add(+(data.unsupress.number), _.lowerCase(data.unsupress.durationType)).valueOf() : undefined,
                ...(!_.isEmpty(similarFindingsToNotUpdate.current) ? { ignoreFindingIds: similarFindingsToNotUpdate.current } : {})
            }
            const {successMessage, errorMessage, exceptionType} = await onOk(response, similarFindings, similarFindingsToNotUpdate.current);
            if (successMessage) {
                ModalUtil.show({
                    content: (
                        <OnSuccess message={successMessage}>
                            {action === FINDING_ACTIONS.ACCEPT_RISK && <CreateTicketNotification bucket={bucket} finding={finding} scope={scope} ticketDetails={ticketDetails} history={history} isTicketCreationInProgress={isTicketCreationInProgress} />}
                        </OnSuccess>
                    ),
                    afterClose,
                });
            } else if(errorMessage){
                ModalUtil.show({
                    content: (
                        <OnError
                            message={errorMessage}
                            response={{
                                ...response,
                                toolName: finding.toolName,
                                productName: finding.product.name,
                                subProductName: finding.subProduct.name,
                                envName: finding.envName,
                                exceptionType,
                            }}
                        />
                    ),
                    afterClose,
                })
            }
            else {
                afterClose();
            }
    }

    const scopeOnChange = (_scope) => {
        setScope(_scope);
        if (_scope === 'FINDING') {
            setShowFindingsTable(false);
            setSimilarFindings(0);
        }
    };

    const payload = useMemo(() => ({
        scope: scope,
        updateType,
        contains: tagCondition === SIMILAR_FINDINGS_TAGS_OPERTAION_TYPES.contains,
        equals: tagCondition === SIMILAR_FINDINGS_TAGS_OPERTAION_TYPES.equals,
        findingId: finding.id,
        findingUpdateTaskType,
    }), [scope, updateType, tagCondition, finding, findingUpdateTaskType])

    useEffect(() => {
        if (scope !== 'FINDING') {
            setLoading(true);
            
            const { promise, cancel } = FindingAPI.similarFindings.count(payload);

            promise.then(response => setSimilarFindings(response)).catch((e) => {
                console.error(e)
                if(e.response.data.message.startsWith("Simila")){
                    message.error("Similar Finding Rules cannot be applied to this finding")
                    setSimilarFindings(undefined)
                }
            }).finally(() => setLoading(false));
            
            return cancel;
        }
    }, [scope, payload]);
    
    const redirectToBucket = () => {
        setShowFindingsTable(true);
    };

    
    // useEffect(() => {
    //     let developerList = systemUsers.map((data) => data.value)
    //     if(developerList.includes(finding.developer)){
    //         form.setFieldsValue({developer: finding.developer})
    //     }
    // },[finding.developer, form, systemUsers])

    const maxThreshold = (_.isNumber(maxAcceptRiskCount) && acceptRiskCount === maxAcceptRiskCount);
    const permission = hasPermission((action === FINDING_ACTIONS.REJECT_RISK) || (action === FINDING_STATUS.OPEN) ? PermissionSetMap.SIMILAR_FINDINGS_REOPEN : isControlledStatusAction ? PermissionSetMap.SIMILAR_FINDINGS_CONTROLLED : PermissionSetMap.SIMILAR_FINDINGS_ACCEPT_RISK);

    const scopeParams = useMemo(() => (
        {
            finding,
            helpText: permission ? '' : ((action === FINDING_ACTIONS.REJECT_RISK) || (action === FINDING_STATUS.OPEN)) ?  'Similar findings reopen permission is required to change scope.' : isControlledStatusAction ? (<span>Similar findings {<Vocabulary name = "controlledStatus"/>} permission is required to change scope.</span>) : (<span>Similar findings {<Vocabulary name = "acceptRisk"/>} permission is required to change scope.</span>),
            permission,
            scopeOnChange,
            redirectToBucket,
            similarFindings,
            showFindingsTable,
            scope,
            updateType,
            setUpdateType,
            setTagCondition
        }
    ), [finding, permission, similarFindings, showFindingsTable, scope, updateType, action, isControlledStatusAction ])

    const scopeFields = useFindingScopeFields({payload, ...scopeParams});

    const fields = useMemo(() => {
        const applyToVersionFindingsField =
            featureFlags.VERSIONS
                ? {
                    label: "Apply to all unresolved versioned Findings",
                    name: "applyToVersionFindings",
                    type: FieldTypes.SWITCH,
                    inline: true,
                }
                : {};
        const fields = (action === FINDING_ACTIONS.REJECT_RISK) || (action === FINDING_STATUS.OPEN) ? [{
            name: "note",
            label: "Note",
            type: FieldTypes.TEXT_AREA,
            required: true,
            customLengthRule: {
                max: 1000,
                message: "Maximum length is 1000 characters"
            },
            props: {
                autoFocus: (action === FINDING_ACTIONS.REJECT_RISK) || (action === FINDING_STATUS.OPEN)
            }},
            applyToVersionFindingsField,
            ...scopeFields
            ] : [{
                name: 'reason',
                label: 'Reason',
                type: FieldTypes.SELECT,
                required: true,
                props: {
                    autoFocus: (action !== FINDING_ACTIONS.REJECT_RISK) || (action !== FINDING_STATUS.OPEN),
                    api: action === FINDING_ACTIONS.ACCEPT_RISK ? FindingAPI.getAcceptRiskReasons : FindingAPI.getControlledReasons
                }
            },
            {
                name: 'unsupress',
                label: <>Re-<Vocabulary name = "open"/></>,
                type: FieldTypes.CUSTOM_DURATION,
                required: true,
                props: {
                    showNeverOption: isControlledStatusAction
                }
            },
            {
                name: "notes",
                label: "Note",
                type: FieldTypes.TEXT_AREA,
                customLengthRule: {
                    max: 4000,
                    message: "Maximum length is 4000 characters" 
                },
                rules: [{
                    required: true,
                    message: "Please enter a note"
                }]
            },
            applyToVersionFindingsField,
            ...scopeFields,
            ...getField(isControlledStatusAction, acceptRiskCount, maxAcceptRiskCount)
        ]

        const tableprops = {
            title: `${similarFindings} Similar Findings`,
            similarFindingsToNotUpdate,
            scope,
            findingUpdateTaskType,
            sourceFinding: finding.id,
            updateType,
            tagCondition,
        };

        if (showFindingsTable) {
            fields.push({
                name: "findingsTable",
                label: '',
                render: () => <SimilarFindingsTable {...tableprops} />
            });
        }

        const scopeIndex =  _.findIndex(fields, { name: "scope" });

        if (((action !== FINDING_ACTIONS.REJECT_RISK) && (action !== FINDING_STATUS.OPEN)) && scopeIndex !== -1 && scope !== 'FINDING' && !_.isUndefined(similarFindings) && TOOLS_NOT_FOR_FUTURE_FINDINGS.indexOf(_.toLower(finding.toolName || finding.source)) === -1) {
            if (updateType === SIMILAR_FINDINGS_TYPES.RULE_BASED) {
                fields.splice(scopeIndex + 1, 0, {
                    name: "applyOnFutureFindings",
                    label: <Tooltip title={!isEmpty(rule) ?
                        `Rule already exists to mark all future findings as ${lowerCase(rule.otherProperties.ACTION_STATUS)}.`
                        : undefined}>Apply to all future findings</Tooltip>,
                    type: FieldTypes.BOOLEAN,
                    disabled: !isEmpty(rule),
                    permission: PermissionSetMap.SIMILAR_FINDINGS_RULE_UPDATE,
                    inline: true
                });
            }
        }

        return fields.filter(f => !_.isEmpty(f));
    }, [acceptRiskCount, action, finding, findingUpdateTaskType, maxAcceptRiskCount, rule, scope, scopeFields, showFindingsTable, similarFindings, tagCondition, updateType, isControlledStatusAction, featureFlags.VERSIONS])

    const showReOpen = findingUpdateTaskType === FINDING_UPDATE_TASK_TYPES.OPEN;
    const modalProps = {
        style: { top: 30 },
        title: <>{showReOpen ? <>Re-<Vocabulary name = "open"/></> : 
            <>Mark {finding?.id} as <Vocabulary name={isControlledStatusAction ? "controlledStatus" : "acceptRisk"} /></>} {CellRenderers.CUSTOMIZED_SEVERITY(finding.severity)} </>,
        onOk: handleOnOk,
        okButtonProps: {
            disabled: maxThreshold || _.isUndefined(similarFindings)
        },
        // okButtonProps: {
        //     disabled: maxThreshold || (isCreateTicket && systemError && action === FINDING_ACTIONS.ACCEPT_RISK && scope === 'FINDING'),
        // },
        okText: showReOpen ? <>Re-<Vocabulary name = "open"/></> : "Submit",
        width: showFindingsTable ? MODAL_SIZE_ULTRA : undefined,
        className: showFindingsTable ? "modal-full-height no-footer" : '',
    }

    return (
        <BaseModal ref={ref} modalProps={modalProps} afterClose={() => afterClose(false)}>
                {maxThreshold ?
                <>
                    <Alert type="warning" showIcon message={<>Maximum <Vocabulary name = "acceptRisk"/> threshold is reached</>} />
                    <div className="m-t-xs"># of times accepted: {acceptRiskCount} out {_.isNumber(maxAcceptRiskCount) ? `${maxAcceptRiskCount} times` : `of unlimited times` } </div>
                </>
                :
                <Spin spinning={loading} indicator={<AppLoader />}>
                    {/* {isCreateTicket && action === FINDING_ACTIONS.ACCEPT_RISK && scope === 'FINDING' && _.isEmpty(ticketId) && systemError && <Alert className="m-b-xs" type="warning" showIcon message={"Ticket system configuration has errored, ticket creation may fail."} />} */}
                    <Form
                        layout="vertical"
                        form={form}
                        initialValues={{ 
                            unsupress: DEFAULTS,
                            scope: "FINDING",
                            note: '',
                            suppressReason: '',
                            // createTicket: isCreateTicket,
                            applyOnFutureFindings: !isEmpty(rule),
                            applyToVersionFindings: true
                        }}
                    >
                        {generateFormFields( maxThreshold ? [] : fields)}
                    </Form>
                </Spin>
                }
        </BaseModal>
    )
})


export default AcceptRiskPopup;

export const OnSuccess = forwardRef(({ message, children, afterClose }, ref) => (
    <SuccessPopup
        okText="Ok"
        ref={ref}
        afterClose={afterClose}
        >
        <Typography.Paragraph>{message}</Typography.Paragraph>
        {children}
    </SuccessPopup>
));

export const OnError = forwardRef(({ message: errorMessage, response, afterClose }, ref) => {
    const isToolMappingSyncError = response?.exceptionType === 'ToolMappingSyncException';
    const handleShowMapping = () => {
        fetchConfigAndRedirect({
            toolName: response.toolName,
            productName: response.productName,
            subProductName: response.subProductName,
            envName: response.envName,
        });
    };

    const handleTriggerSync = async () => {
        const { findingId, productName, subProductName, envName, exceptionType, ...syncPayload } = response;
        const messageReference = message.loading("Syncing...");
        await FindingAPI.triggerSyncBDStatus(findingId, {
            ...syncPayload,
            reason: 'Finding out of sync'
        }).promise;
        messageReference();
        message.success("Sync successfully");
    };

    return (
        <WarningPopup
            okText={isToolMappingSyncError ? "Show Mapping" : "Trigger A Sync"}
            ref={ref}
            title='Conflict'
            promptMessage={errorMessage}
            afterClose={afterClose}
            onOk={isToolMappingSyncError ? handleShowMapping : handleTriggerSync}
        />
    );
});

function getField(isControlledStatusAction, acceptRiskCount, maxAcceptRiskCount) {
    if(isControlledStatusAction) {
        return [];
    }

    return[{
        name: "suppressedCount",
        label: "# of times accepted",
        render: (text) => <Text>{acceptRiskCount} out {_.isNumber(maxAcceptRiskCount) ? `${maxAcceptRiskCount} times` : `of unlimited times` }</Text>
    }]
}

export const CreateTicketNotification = ({ bucket, finding, scope, ticketDetails, history, isTicketCreationInProgress }) => {
    if (scope !== 'FINDING') {
        return null;
    }
    const { shouldConfigureOrEnableJira, ticketId, ticketSystemType } = ticketDetails;

    return (
        shouldConfigureOrEnableJira ? 
            <AuthorisedContainer permission={PermissionSetMap.CREATE_TICKETS}>
                <Typography.Link onClick={() => {
                history.push("/integrations");
            }}>Please Configure or enable the ticketing system</Typography.Link>
            </AuthorisedContainer>
            : 
            _.isEmpty(ticketId) && !isTicketCreationInProgress ?
                <AuthorisedContainer permission={PermissionSetMap.CREATE_TICKETS}>
                    <Typography.Link onClick={() => {
                        bucket.addFindings([finding.id], [finding]);
                        history.push('/findings/createTicket');
                }}>Click here to create {getTicketSystemName(ticketSystemType)} ticket</Typography.Link>
                </AuthorisedContainer>
                :
                null
    
    );
};
